/*
  The Katha Circle: 10% off a first order, held for 48 hours.
  Drives every [data-kh-hold] box (snippets/kh-hold-box.liquid: footer, account page, Circle page).
  Uses the pop-up's saved hold (localStorage "kh-hold": { code, ends_at } or { ended: true }), so the
  pop-up, these boxes and the bag all show the same code and the same clock.
  Signed-in customers: the box carries a signature from the theme ("hold|email|time"); Atelier's
  circle-hold-code looks their hold up (peek) and starts one only when they ask, or right after they
  register with the email box ticked (sessionStorage "kh-joined") or say yes to emails (?customer_posted=true).
  While the code is held it also remembers the pieces they open and what is in the bag (with the code's own
  key, given with the code), for the one reminder email Atelier sends 24 hours in (circle-hold-reminder).
*/
(function () {
  if (window.khHold) return;
  var KEY = 'kh-hold', JOINED = 'kh-joined';
  var MON = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var get = function () { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
  var put = function (v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var live = function (h) { return !!(h && h.code && !h.ended && new Date(h.ends_at).getTime() > Date.now()); };
  var tiles = function (ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    return '<span>' + pad(Math.floor(t / 3600)) + '<small>hrs</small></span><span>' + pad(Math.floor(t / 60) % 60) +
      '<small>min</small></span><span>' + pad(t % 60) + '<small>sec</small></span>';
  };
  var boxes = function () { return [].slice.call(document.querySelectorAll('[data-kh-hold]')); };
  var hold = get(), busy = false, err = '';

  var show = function (box, name) {
    [].forEach.call(box.querySelectorAll('[data-h]'), function (el) { el.hidden = el.getAttribute('data-h') !== name; });
  };
  var paint = function () {
    boxes().forEach(function (box) {
      var e = box.querySelector('[data-h-err]');
      if (e) { e.hidden = !err; e.textContent = err; }
      if (busy) return show(box, 'busy');
      if (live(hold)) {
        var d = new Date(hold.ends_at);
        box.querySelector('[data-h-code]').textContent = hold.code;
        box.querySelector('[data-h-use]').href = '/discount/' + encodeURIComponent(hold.code) + '?redirect=/collections/all';
        box.querySelector('[data-h-ends]').textContent = DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()] + ', ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
        box.querySelector('[data-h-clock]').innerHTML = tiles(d - Date.now());
        return show(box, 'held');
      }
      if (hold && (hold.ended || hold.code)) return show(box, 'ended');
      show(box, box.getAttribute('data-start'));
    });
  };
  var call = function (box, extra) {
    var body = { email: box.getAttribute('data-email'), ts: +box.getAttribute('data-ts'), sig: box.getAttribute('data-sig') };
    for (var k in extra) body[k] = extra[k];
    return fetch(box.getAttribute('data-fn'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); }).catch(function () { return null; });
  };
  var take = function (d) {
    if (d && d.ok) { hold = { code: d.code, ends_at: d.ends_at, key: d.key }; put(hold); }
    else if (d && d.ended) { hold = { ended: true }; put(hold); }
  };
  var start = function (box) {
    if (busy) return;
    busy = true; err = ''; paint();
    call(box, {}).then(function (d) {
      busy = false;
      if (d && (d.ok || d.ended)) take(d);
      else if (d && d.subscribe) boxes().forEach(function (b) { if (b.getAttribute('data-sig')) b.setAttribute('data-start', 'sub'); });
      else if (d && d.ordered) err = 'Your first order is in, so the 10% for it has been used. Thank you.';
      else err = (d && d.error) || 'That did not go through. Try again in a moment.';
      paint();
    });
  };

  var init = function () {
    var all = boxes();
    if (!all.length) return;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-h-start]');
      if (!b) return;
      e.preventDefault();
      var box = b.closest('[data-kh-hold]');
      if (box && box.getAttribute('data-sig')) start(box);
    });
    // the pop-up saved a new hold: show it everywhere at once
    document.addEventListener('kh:hold', function () { hold = get(); paint(); });
    var signed = all.filter(function (b) { return b.getAttribute('data-sig'); })[0];
    if (signed) hold = null; // signed in: Atelier says which hold is theirs (a saved one may be someone else's on this device)
    paint();
    if (signed && signed.getAttribute('data-start') === 'ask-member') {
      var joined = /[?&]customer_posted=true/.test(location.search);
      try { if (sessionStorage.getItem(JOINED) === '1') joined = true; sessionStorage.removeItem(JOINED); } catch (e) {}
      call(signed, { peek: true }).then(function (d) {
        if (d && (d.ok || d.ended)) { take(d); paint(); }
        else if (d && d.none && joined) start(signed);
      });
    }
    setInterval(function () {
      if (!hold || !hold.code || hold.ended) return;
      if (!live(hold)) { hold.ended = true; put(hold); return paint(); }
      var html = tiles(new Date(hold.ends_at) - Date.now());
      boxes().forEach(function (b) { var c = b.querySelector('[data-h-clock]'); if (c) c.innerHTML = html; });
    }, 1000);
  };
  // What they open and bag while the 10% is held, for the reminder email. Sent only when it changed.
  var SEEN = 'kh-hold-seen', SENT = 'kh-hold-sent';
  var FN = 'https://tpuzlucjbggmpajctkrx.supabase.co/functions/v1/circle-hold-code';
  var track = function () {
    var h = get();
    if (!live(h) || !h.key || h.demo) return;
    var seen = [];
    try { seen = JSON.parse(localStorage.getItem(SEEN) || '[]') || []; } catch (e) {}
    var m = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (m && m.id) {
      var id = String(m.id);
      seen = [id].concat(seen.filter(function (x) { return x !== id; })).slice(0, 6);
      try { localStorage.setItem(SEEN, JSON.stringify(seen)); } catch (e) {}
    }
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var bag = (c.items || []).slice(0, 20).map(function (i) { return { v: String(i.variant_id), q: i.quantity }; });
      var body = JSON.stringify({ code: h.code, key: h.key, seen: seen, bag: bag });
      var was = null;
      try { was = localStorage.getItem(SENT); } catch (e) {}
      if (was === body) return;
      return fetch(FN, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.ok) { try { localStorage.setItem(SENT, body); } catch (e) {} } });
    }).catch(function () {});
  };
  var soon = 0, later = function () { clearTimeout(soon); soon = setTimeout(track, 1500); };
  ['product:added', 'cart:refresh', 'kh:hold'].forEach(function (n) { document.addEventListener(n, later, true); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') track(); });

  window.khHold = { paint: paint, track: track };
  var go = function () { init(); track(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
